import mine from '../messageBox.vue';

export default box => {

    /**
     * content: [Number ,String ,Object] 内容
     * buttons: Array [{key: String,label: [String,Object] }] 按钮内容
     */
    return function (...args) {

        let first = args[0],
            cons_first = first?.constructor;

        let obj = {};

        let props = {};
        
        if (cons_first == Object) {
            props.content = first.content
            first.buttons && (props.buttons = first.buttons)

            obj = Object.assign(first)

            delete obj.content
            delete obj.buttons
        } else {
            props.content = first
            props.buttons = [
                {
                    key: 'ok',
                    label: '确定'
                },
                {
                    key: 'cancel',
                    label: '取消'
                }
            ]
        }

        return box(mine,{
            ...obj,
            props,
            // 禁用窗口改变大小
            unvariable: true,
            ons: ['onButtonClick']
        })
    }
}